export default __webpack_public_path__ + "img/a0ed5fff514ca642aea0c088ab59d4cc.svg";